import { AccountInfo } from '@solana/web3.js';

/**
 * Parse the raw amount from SPL Token account data.
 * SPL Token account layout:
 * - mint: 32 bytes (offset 0)
 * - owner: 32 bytes (offset 32)
 * - amount: 8 bytes u64 LE (offset 64)
 */
function parseTokenAccountAmount(accountInfo: AccountInfo<Buffer>): bigint {
	// Amount is at offset 64, 8 bytes, u64 little-endian
	return accountInfo.data.readBigUInt64LE(64);
}

/**
 * Parse SPL Token account data and return uiAmount (with decimals applied).
 * @param accountInfo - The account info from WebSocket or RPC
 * @param decimals - The number of decimals for this token
 * @returns The balance as a number with decimals applied (uiAmount)
 */
export function parseTokenAccountBalance(
	accountInfo: AccountInfo<Buffer>,
	decimals: number
): number {
	const rawAmount = parseTokenAccountAmount(accountInfo);
	// Convert to number with decimals
	// For large numbers, this might lose precision, but matches current behavior
	return Number(rawAmount) / Math.pow(10, decimals);
}
